import { Auth0Provider } from '@auth0/auth0-react';

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = import.meta.env.VITE_REACT_APP_AUTH0_DOMAIN || '';
  const clientId = import.meta.env.VITE_REACT_APP_AUTH0_CLIENT_ID || '';
  const audience = import.meta.env.VITE_REACT_APP_AUTH0_AUDIENCE || '';

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      audience={audience}
      redirectUri={`${window.location.origin}/packages`}
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
